import { Directive, HostListener } from '@angular/core';
import { UIRouter }               from '@uirouter/core';

@Directive({
  selector: '[save-route]'
})
export class SaveRouteDirective {

  constructor (
    private router: UIRouter
  ) {}

  @HostListener('click')
  onClick () : void {
    const current = this.router.globals.current;
    const params  = this.router.globals.params;

    if (current?.name) {
      sessionStorage.setItem('savedRoute', JSON.stringify({
        name  : current.name,
        params: params
      }));
    }
  }
}
